import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DValorPeriodico } from '@dian/api-basicos-parametricas';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_956';
const VAL_PERIODICO_110 = 110;
const ANNIODECLARACION = 2022;

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Valor Efectivo', listHelp: ['792'] },
  { text: "2", active: false, completed: false, tooltip: 'Valor Inversiones', listHelp: ['792'] }
];

@Component({
  selector: 'app-renta-pensiones-sobreviviente-modal',
  templateUrl: './renta-pensiones-sobreviviente-modal.component.html',
  styleUrls: ['./renta-pensiones-sobreviviente-modal.component.css'],
  providers: [
    DOperacionesMatematicasServicio,
    DBasicosParametricasServicios,
    DNotificacionServicio
  ]
})
export class RentaPensionesSobrevivienteExteriorModalComponent extends HandlerModal implements OnInit {
  
  saveModel = new EventEmitter();
  public showSave:boolean;
  public UVT:string='';

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dialogRef: MatDialogRef<RentaPensionesSobrevivienteExteriorModalComponent>,
    public dNotificacionServicio: DNotificacionServicio,
    private dBasicosParametricasServicios: DBasicosParametricasServicios,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();

  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_723 == undefined)this.model.doc.cuerpo.cs_id_723="0";
    if(this.model.doc.cuerpo.cs_id_724 == undefined)this.model.doc.cuerpo.cs_id_724="0";
    if(this.model.doc.cuerpo.cs_id_725 == undefined)this.model.doc.cuerpo.cs_id_725="0";
    if(this.model.doc.cuerpo.cs_id_726 == undefined)this.model.doc.cuerpo.cs_id_726="0";
    
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 723:
        this.operacionCs723();
        break;
      case 724:
        this.operacionCs724();
        break;      
      case 725:
        this.operacionCs725();
        break;  
        case 726:
          this.operacionCs726();
        break; 
             
   }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
  }

  operacionCs723(){
    this.model.doc.cuerpo.cs_id_723 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_723,true);

    this.operacionCs726();
  }
  
  operacionCs724(){
    //this.model.doc.cuerpo.cs_id_724 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_724,true);

    const cas724= "" + this.model.doc.cuerpo.cs_id_724 ;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas724,"0")) {
      // this.dNotificacionServicio.mostrarDialogoInformacion('Indique el número de meses a que corresponde el valor recibido.');
      return;
    }

    this.operacionCs726();
  }
  
  operacionCs725(){
    this.model.doc.cuerpo.cs_id_725 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_725,true);
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_725, this.model.doc.cuerpo.cs_id_723)){
        this.dNotificacionServicio.mostrarDialogoInformacion('El valor de sus aportes obligatorios a salud y a fondo de solidaridad pensional no puede ser mayor que ingresos por pensión');
        this.model.doc.cuerpo.cs_id_725 = this.model.doc.cuerpo.cs_id_723;
      }
  }
  
  operacionCs726(){
    const cas723 = this.model.doc.cuerpo.cs_id_723; //Valor Pension total por periodo
    const cas724 = "" + this.model.doc.cuerpo.cs_id_724; //Periodo en menses
    const cas725 = this.model.doc.cuerpo.cs_id_725;  //Aportes Obligatorios total por periodo 
    const rentaLiquida = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,cas723,cas725);
    
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas723,"0") 
    || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas724,"0")) 
    {
      return 
    }
    
    const valorTope = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION,cas723,cas724); //pension Mensual
    const valorApOblMen = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION,cas725,cas724);     ; //Aportes obligatorios salud y pensin valor mensual
    const valorTope2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,valorTope,valorApOblMen);
    
    let cas726 = "0";
    let miluvt = "38004000";
    if(this.UVT != '')
    {
      miluvt=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.UVT,'1000');
    }
   
    if ( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,valorTope,miluvt)
    || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,valorTope2,miluvt) )  //si el valor líquido de la pension mensual es menor que 1.00 uvts renta exenta es el valor de la pension 
    {
      cas726 =  rentaLiquida;
    } else {
      
      cas726 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,miluvt,cas724); //máxima renta excenta mensual  es 1.000 uvt 
    }
    
    this.model.doc.cuerpo.cs_id_726 = cas726;
   
  }
   //UVT 
   private obtenerValorPeriodico110(): void {
    this.dBasicosParametricasServicios.obtenerValorPeriodico(VAL_PERIODICO_110, ANNIODECLARACION).subscribe(
      data => this.setObjectFromResponse(data),
      error => console.log(error)
    )
  }
  private setObjectFromResponse(data: any): void {
    
        let model=<DValorPeriodico>data;
        this.UVT = String(model.valor);
     
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-pensiones/renta-pensiones-sobreviviente-modal/renta-pensiones-sobreviviente-modal.component.ts